import React, { useState, useEffect } from 'react';
import { FaBell, FaBellSlash, FaSpinner } from 'react-icons/fa';
import api from '../../api/api';
import { urlBase64ToUint8Array } from '../../utils/helpers';

// Your VAPID Public Key
const VAPID_PUBLIC_KEY = "BBtSN3ZjmBjiT-jODQkhdTKl2Sb9F-4F13B1ibE2ENbRIm6_UPgF8r-X-pUN7Hs_F2Bg_cGdCm4pDDmcgktH_Jg";

const EnableNotificationsButton = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSubscription = async () => {
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        try {
          const registration = await navigator.serviceWorker.ready;
          const subscription = await registration.pushManager.getSubscription();
          setIsSubscribed(!!subscription);
        } catch (error) {
          console.error("Error checking subscription:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    checkSubscription();
  }, []);

  const handleSubscribe = async () => {
    if (!('serviceWorker' in navigator && 'PushManager' in window)) {
      alert('Push notifications are not supported by your browser.');
      return;
    }
      
    setLoading(true);
    try {
      const registration = await navigator.serviceWorker.ready;
      const existingSubscription = await registration.pushManager.getSubscription();

      if (existingSubscription) {
        await existingSubscription.unsubscribe();
        await api.delete('/notifications/unsubscribe', { data: { endpoint: existingSubscription.endpoint } });
        setIsSubscribed(false);
      } else {
        const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: applicationServerKey,
        });
        
        await api.post('/notifications/subscribe', subscription);
        setIsSubscribed(true);
      }
    } catch (error) {
      if (Notification.permission === 'denied') {
        alert('You have blocked notifications. Please enable them in your browser settings.');
      } else {
        console.error('Failed to subscribe:', error);
        alert('An error occurred while trying to subscribe to notifications.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  if (!('PushManager' in window)) {
    return null;
  }

  // Simplified color logic
  const buttonClasses = `flex items-center justify-center w-full sm:w-auto px-6 py-2 text-base font-semibold rounded-full transition-colors disabled:opacity-50 shadow-soft font-body`;

  const colorClasses = isSubscribed
    ? 'bg-red-500 text-white hover:bg-red-600' // Red for disabling
    : 'bg-green-500 text-white hover:bg-green-600'; // Green for enabling

  return (
    <button 
      onClick={handleSubscribe} 
      disabled={loading} 
      className={`${buttonClasses} ${colorClasses}`}
    >
      {loading ? (
        <FaSpinner className="animate-spin text-gray-400" />
      ) : isSubscribed ? (
        <FaBellSlash className="mr-2" />
      ) : (
        <FaBell className="mr-2" />
      )}
      <span>
        {loading ? 'Loading...' : (isSubscribed ? 'Disable Notifications' : 'Enable Notifications')}
      </span>
    </button>
  );
};

export default EnableNotificationsButton;